import React, { useState } from "react";
import ReusableModal from "components/Modals/ReusableModal";
import ReusableInput from "components/Inputs/ReusableInput";
import { useCustomNotification } from "components/Toasts/OpenNotification";

const ManageDeletionModal = ({ isOpen, onClose, onConfirm, onConfirmPassword, firstName, lastName }) => {
  const [password, setPassword] = useState("");
  const notify = useCustomNotification();

  const bodyMessage = `
    User <strong>${firstName} ${lastName}</strong> has requested to delete their account.<br/>
    Please enter your admin password to confirm this action.
  `;

  const handleConfirm = async () => {
    if (!password.trim()) {
      notify({
        type: "error",
        message: "Password Required",
        description: "Please enter your admin password to proceed.",
        duration: 5,
      });
      return;
    }

    const result = await onConfirmPassword(password);
    console.log(result);
    if (result?.success) {
      await onConfirm();
      setPassword("");
      onClose();
    }
  };



  const handleClose = () => {
    setPassword("");
    onClose();
  };

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Manage Account Deletion"
      confirmLabel="OK"
      cancelLabel="Cancel"
      bodyMessage={
        <div>
          <div dangerouslySetInnerHTML={{ __html: bodyMessage }} />
          <div style={{ marginTop: "16px" }}>
            <ReusableInput
              type="password"
              name="adminPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>
        </div>
      }

    />
  );
};

export default ManageDeletionModal;
